/**
 * Swaps the content of an element for a spinner and back.
 *
 * Every matched element keeps its own state: a selector that matches several elements (a
 * page with more than one uploader, a list of buttons) can not restore one element with
 * the content of another one, and can not leave an element stuck on the spinner.
 */
$.fn.loading = function(loading = true) {
  return this.each(function() {
    const elem = $(this);
    const elementRealContent = elem.data('element-real-content');
    const currentlyLoading = Boolean(elementRealContent);

    let elementsRealWidth = elem.data('element-real-width');
    if (!elementsRealWidth) {
      elementsRealWidth = elem.css('width');
      elem.data('element-real-width', elem.css('width'));
    }

    if (loading && currentlyLoading) {
      return;
    }

    if (loading) {
      elem.css('width', elementsRealWidth);

      const elementContent = elem.contents();
      elem.data('element-real-content', elementContent);
      elem.html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="sr-only">Loading...</span>`);
      elem.attr('disabled', true);
    } else if (currentlyLoading) {
      elem.css('width', '');

      elem.html('').append(elementRealContent);
      elem.data('element-real-content', null);
      elem.removeAttr('disabled');
    }
  });
};
